import { useRef, useState, useEffect, useCallback } from 'react';

interface UseVideoVisibilityOptions {
  /** Visibility threshold (0-1). Default 0.5 means 50% visible */
  threshold?: number;
  /** Root margin for earlier/later triggering */
  rootMargin?: string;
}

export function useVideoVisibility(options: UseVideoVisibilityOptions = {}) {
  const { threshold = 0.5, rootMargin = '100px 0px' } = options;
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold, rootMargin }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [threshold, rootMargin]);

  return { containerRef, isVisible };
}
